import { useEffect } from 'react';
import { useTheme } from './ThemeProvider';
import './Toast.css';

interface ToastProps {
  message: string | null;
  duration?: number;
  onDismiss: () => void;
}

export function Toast({ message, duration = 2000, onDismiss }: ToastProps) {
  const { theme } = useTheme();

  useEffect(() => {
    if (message === null) {
      return;
    }

    const timer = setTimeout(() => {
      onDismiss();
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [message, duration, onDismiss]);

  if (message === null) {
    return null;
  }

  return (
    <div
      className="toast"
      style={{
        position: 'fixed',
        bottom: theme.spacing.xl,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: theme.colours.background.elevated,
        color: theme.colours.text.primary,
        padding: `${theme.spacing.md} ${theme.spacing.lg}`,
        borderRadius: theme.borders.radius.lg,
        boxShadow: theme.shadows.xl,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize.md,
        fontWeight: theme.typography.fontWeight.medium,
        zIndex: 10000,
        minWidth: '250px',
        maxWidth: '90vw',
        textAlign: 'center',
        animation: 'toastFadeIn 0.3s ease-out',
      }}
    >
      {message}
    </div>
  );
}
